import { Outlet } from '@tanstack/react-router';
import * as React from 'react';
import styled from 'styled-components';

import { Empty } from '@creditornot/cb-placeholders';
import { CountrySelector } from 'common/components/cookbook/CountrySelector/CountrySelector';
import { NavigationBar } from 'common/components/cookbook/NavigationBar/NavigationBar';
import { ViewMeta } from 'common/components/cookbook/ViewMeta';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSelectedCountryCodes } from 'common/hooks/useSelectedCountryCodes';

const StyledEmpty = styled(Empty)`
  margin: auto;
`;

const RequireSingleCountry: React.FC = () => {
  const format = useFormatMessage();
  const title = format('components.require_single_country.title');

  const countryCodes = useSelectedCountryCodes();

  return countryCodes.length !== 1 ? (
    <ViewMeta title={title}>
      <NavigationBar title={title} titleContent={<CountrySelector />} />
      <StyledEmpty title={format('components.require_single_country.message')} />
    </ViewMeta>
  ) : (
    <Outlet />
  );
};

export default RequireSingleCountry;
